import React, { createContext, useState, useContext, useCallback } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';

import { DB } from '~/services/firebase';
import { useAuth } from './auth';
import IDeliverymen from '~/interfaces/IDeliverymen';

interface DeliverymenContextData {
  deliverymens: IDeliverymen[] | null;
  loadDeliverymens(): void;
}

const DeliverymenContext = createContext<DeliverymenContextData>(
  {} as DeliverymenContextData,
);

export const DeliverymenProvider: React.FC = ({ children }) => {
  const { user } = useAuth();
  const [deliverymens, setDeliverymens] = useState<IDeliverymen[] | null>(null);

  const loadDeliverymens = useCallback(async () => {
    const q = query(
      collection(DB, 'deliverymen'),
      where('user_id', '==', user.uid),
    );
    const querySnapshot = await getDocs(q);

    const items: IDeliverymen[] = [];

    querySnapshot.docs.forEach(item => {
      const parseItem = {
        ...item.data(),
        uid: item.id,
      } as IDeliverymen;

      items.push(parseItem);
    });

    setDeliverymens(items);
  }, [user]);

  return (
    <DeliverymenContext.Provider
      value={{
        deliverymens,
        loadDeliverymens,
      }}
    >
      {children}
    </DeliverymenContext.Provider>
  );
};

export function useDeliverymen(): DeliverymenContextData {
  const context = useContext(DeliverymenContext);
  return context;
}
